// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    applicationId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    applicationId: z.string().min(1).max(21),
});
export const OrganizationApplicationRelations = Object.freeze({
    table: 'organization_application_relations',
    tableSingular: 'organization_application_relation',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        applicationId: 'application_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'applicationId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
